import PagePlaceholder from "../components/PagePlaceholder";

/**
 * The Inventory view. Placeholder until the domain model is defined.
 */
function Inventory() {
  return (
    <PagePlaceholder
      title="Inventory"
      summary="Placeholder. This view will list the application portfolio sourced from the datahub application-portfolio-management ontology."
    />
  );
}

export default Inventory;
